import { Tooltip } from "@mui/material";
import { tv } from "tailwind-variants";

/**
 * Style
 */

const { bg, text } = tv({
  slots: {
    bg: "flex justify-center items-center w-[3rem] py-[0.2rem] text-xs font-bold rounded cursor-pointer",
    text: "font-semibold"
  },
  variants: {
    color: {
      red: {
        bg: "bg-red-500",
        text: "text-white"
      },
      blue: {
        bg: "bg-blue-500",
        text: "text-white"
      },
      yellow: {
        bg: "bg-yellow-400",
        text: "text-black"
      },
      gray: {
        bg: "bg-gray-400",
        text: "text-white"
      },
      green: {
        bg: "bg-primary-green",
        text: "text-white"
      },
    }
  }
})()

/**
 * TagStatus
 */

interface Props {
  color: "red" | "blue" | "yellow" | "green" | "gray"
  title: string,
  description: string
}

function TagStatus({ color, title, description }: Props) {
  return (
    <>
      <Tooltip title={description}>
        <div className={bg({ color: color })}>
          <h1 className={text({ color: color })}>{title}</h1>
        </div>
      </Tooltip>
    </>
  );
}

export default TagStatus;